class WarehouseListModel {
    constructor({ warehouseList = null } = {}) {
      this.warehouseList = warehouseList;
    }
  
    static fromJson(json) {
      return new WarehouseListModel({
        warehouseList: json.warehouse_list
          ? json.warehouse_list.map((e) => WarehouseList.fromJson(e))
          : null,
      });
    }
  
    toJson() {
      return {
        warehouse_list: this.warehouseList
          ? this.warehouseList.map((e) => e.toJson())
          : null,
      };
    }
  }
  
  class WarehouseList {
    constructor({
      locationId = null,
      locationName = null,
      companyId = null,
      companyName = null,
      countryId = null,
      territory = null,
      cityId = null,
      city = null,
      locationAddress = null,
      landmark = null,
      state = null,
      postalArea = null,
      locationCode = null,
      locationCountryCode = null,
      locationTypeCode = null,
      locationType = null,
      phoneCode = null,
      latitude = null,
      longitude = null,
      phoneNumber = null,
      email = null,
      pickupTime = null,
      workflowId = null,
      workflowCode = null,
      assignedDriver = null,
      assignedDriverUid = null,
      updated = null,
      originHubName = null,
      originHubId = null,
      returnHubName = null,
      returnHubId = null,
      returnInfoName = null,
      nationalAddress = null,
      vendorId = null,
      vendorName = null,
      exceptionHub = null,
      numDeliverySlots = null,
      facilitySlots = null,
      storageShipmentCapacity = null,
      storageWeightCapacity = null,
      storageWeightUnit = null,
      storageVolumetricCapacity = null,
      storageVolumetricUnit = null,
      processingShipmentCapacity = null,
      processingWeightCapacity = null,
      processingWeightUnit = null,
      processingVolumetricCapacity = null,
      processingVolumetricUnit = null,
    } = {}) {
      this.locationId = locationId;
      this.locationName = locationName;
      this.companyId = companyId;
      this.companyName = companyName;
      this.countryId = countryId;
      this.territory = territory;
      this.cityId = cityId;
      this.city = city;
      this.locationAddress = locationAddress;
      this.landmark = landmark;
      this.state = state;
      this.postalArea = postalArea;
      this.locationCode = locationCode;
      this.locationCountryCode = locationCountryCode;
      this.locationTypeCode = locationTypeCode;
      this.locationType = locationType;
      this.phoneCode = phoneCode;
      this.latitude = latitude;
      this.longitude = longitude;
      this.phoneNumber = phoneNumber;
      this.email = email;
      this.pickupTime = pickupTime;
      this.workflowId = workflowId;
      this.workflowCode = workflowCode;
      this.assignedDriver = assignedDriver;
      this.assignedDriverUid = assignedDriverUid;
      this.updated = updated;
      this.originHubName = originHubName;
      this.originHubId = originHubId;
      this.returnHubName = returnHubName;
      this.returnHubId = returnHubId;
      this.returnInfoName = returnInfoName;
      this.nationalAddress = nationalAddress;
      this.vendorId = vendorId;
      this.vendorName = vendorName;
      this.exceptionHub = exceptionHub;
      this.numDeliverySlots = numDeliverySlots;
      this.facilitySlots = facilitySlots
        ? facilitySlots.map((slot) => FacilitySlots.fromJson(slot))
        : null;
      this.storageShipmentCapacity = storageShipmentCapacity;
      this.storageWeightCapacity = storageWeightCapacity;
      this.storageWeightUnit = storageWeightUnit;
      this.storageVolumetricCapacity = storageVolumetricCapacity;
      this.storageVolumetricUnit = storageVolumetricUnit;
      this.processingShipmentCapacity = processingShipmentCapacity;
      this.processingWeightCapacity = processingWeightCapacity;
      this.processingWeightUnit = processingWeightUnit;
      this.processingVolumetricCapacity = processingVolumetricCapacity;
      this.processingVolumetricUnit = processingVolumetricUnit;
    }
  
    static fromJson(json) {
      return new WarehouseList({
        locationId: json.location_id,
        locationName: json.location_name,
        companyId: json.company_id,
        companyName: json.company_name,
        countryId: json.country_id,
        territory: json.territory,
        cityId: json.city_id,
        city: json.city,
        locationAddress: json.location_address,
        landmark: json.landmark,
        state: json.state,
        postalArea: json.postal_area,
        locationCode: json.location_code,
        locationCountryCode: json.location_country_code,
        locationTypeCode: json.location_type_code,
        locationType: json.location_type,
        phoneCode: json.phone_code,
        latitude: json.latitude,
        longitude: json.longitude,
        phoneNumber: json.phone_number,
        email: json.email,
        pickupTime: json.pickup_time,
        workflowId: json.workflow_id,
        workflowCode: json.workflow_code,
        assignedDriver: json.assigned_driver,
        assignedDriverUid: json.assigned_driver_uid,
        updated: json.updated,
        originHubName: json.origin_hub_name,
        originHubId: json.origin_hub_id,
        returnHubName: json.return_hub_name,
        returnHubId: json.return_hub_id,
        returnInfoName: json.return_info_name,
        nationalAddress: json.national_address,
        vendorId: json.vendor_id,
        vendorName: json.vendor_name,
        exceptionHub: json.exception_hub,
        numDeliverySlots: json.num_delivery_slots,
        facilitySlots: json.facility_slots
          ? json.facility_slots.map((slot) => FacilitySlots.fromJson(slot))
          : null,
        storageShipmentCapacity: json.storage_shipment_capacity,
        storageWeightCapacity: json.storage_weight_capacity,
        storageWeightUnit: json.storage_weight_unit,
        storageVolumetricCapacity: json.storage_volumetric_capacity,
        storageVolumetricUnit: json.storage_volumetric_unit,
        processingShipmentCapacity: json.processing_shipment_capacity,
        processingWeightCapacity: json.processing_weight_capacity,
        processingWeightUnit: json.processing_weight_unit,
        processingVolumetricCapacity: json.processing_volumetric_capacity,
        processingVolumetricUnit: json.processing_volumetric_unit,
      });
    }
  
    toJson() {
      return {
        location_id: this.locationId,
        location_name: this.locationName,
        company_id: this.companyId,
        company_name: this.companyName,
        country_id: this.countryId,
        territory: this.territory,
        city_id: this.cityId,
        city: this.city,
        location_address: this.locationAddress,
        landmark: this.landmark,
        state: this.state,
        postal_area: this.postalArea,
        location_code: this.locationCode,
        location_country_code: this.locationCountryCode,
        location_type_code: this.locationTypeCode,
        location_type: this.locationType,
        phone_code: this.phoneCode,
        latitude: this.latitude,
        longitude: this.longitude,
        phone_number: this.phoneNumber,
        email: this.email,
        pickup_time: this.pickupTime,
        workflow_id: this.workflowId,
        workflow_code: this.workflowCode,
        assigned_driver: this.assignedDriver,
        assigned_driver_uid: this.assignedDriverUid,
        updated: this.updated,
        origin_hub_name: this.originHubName,
        origin_hub_id: this.originHubId,
        return_hub_name: this.returnHubName,
        return_hub_id: this.returnHubId,
        return_info_name: this.returnInfoName,
        national_address: this.nationalAddress,
        vendor_id: this.vendorId,
        vendor_name: this.vendorName,
        exception_hub: this.exceptionHub,
        num_delivery_slots: this.numDeliverySlots,
        facility_slots: this.facilitySlots
          ? this.facilitySlots.map((slot) => slot.toJson())
          : null,
        storage_shipment_capacity: this.storageShipmentCapacity,
        storage_weight_capacity: this.storageWeightCapacity,
        storage_weight_unit: this.storageWeightUnit,
        storage_volumetric_capacity: this.storageVolumetricCapacity,
        storage_volumetric_unit: this.storageVolumetricUnit,
        processing_shipment_capacity: this.processingShipmentCapacity,
        processing_weight_capacity: this.processingWeightCapacity,
        processing_weight_unit: this.processingWeightUnit,
        processing_volumetric_capacity: this.processingVolumetricCapacity,
        processing_volumetric_unit: this.processingVolumetricUnit,
      };
    }
  }
  
  class FacilitySlots {
    constructor({ startTime = null, endTime = null } = {}) {
      this.startTime = startTime;
      this.endTime = endTime;
    }
  
    static fromJson(json) {
      return new FacilitySlots({
        startTime: json.start_time,
        endTime: json.end_time,
      });
    }
  
    toJson() {
      return {
        start_time: this.startTime,
        end_time: this.endTime,
      };
    }
  }
  export {WarehouseListModel,WarehouseList};